import React from 'react';
import { GetStaticPropsContext } from 'next';
import { getDate } from '../../components/common/HelperFunctions';
import Link from '../../components/common/Link';
import PageTitle from '../../components/common/PageTitle';
import { getClient } from '../../contentful/contentfulClient';
import renderDocument from '../../contentful/renderDocument';

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const MINUTES = 60;
  const revalidate = 60 * MINUTES;
  const client = getClient(context.preview);

  const entries = await client.getEntries({
    content_type: 'news',
    'fields.permalink': context.params.permalink,
  });

  const news = entries.items[0];

  if (!news) {
    return {
      notFound: true,
    };
  }

  return {
    props: news.fields,
    revalidate, // In seconds
  };
}
const NewsArticle = ({ title, date, article }) => (
  <section className="news clearfix">
    <PageTitle title={title} />
    <div className="news-header" style={{ position: 'relative' }}>
      <h2 className="title">{title}</h2>

      <div style={{ position: 'absolute', left: 10, bottom: 5, fontSize: 15 }}>
        <Link to="/news">
          <span className="icon-bars" /> View All News
        </Link>
      </div>
      <div style={{ position: 'absolute', right: 10, bottom: 5, fontSize: 20 }}>
        <span className="icon-calendar" /> {getDate(date)}
      </div>
    </div>
    <div className="container article-container col-md-6 col-md-offset-3">
      {renderDocument(article)}
    </div>
  </section>
);

export default NewsArticle;
